import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecordPaymentInPatientHeaderMutationVariables = Types.Exact<{
  input: Types.RecordPaymentInput;
}>;


export type RecordPaymentInPatientHeaderMutation = { readonly __typename?: 'Mutation', readonly recordPayment: { readonly __typename?: 'Payment', readonly id: string } };


export const RecordPaymentInPatientHeaderDocument = gql`
    mutation RecordPaymentInPatientHeader($input: RecordPaymentInput!) {
  recordPayment(input: $input) {
    id
  }
}
    `;
export type RecordPaymentInPatientHeaderMutationFn = Apollo.MutationFunction<RecordPaymentInPatientHeaderMutation, RecordPaymentInPatientHeaderMutationVariables>;

/**
 * __useRecordPaymentInPatientHeaderMutation__
 *
 * To run a mutation, you first call `useRecordPaymentInPatientHeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPaymentInPatientHeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPaymentInPatientHeaderMutation, { data, loading, error }] = useRecordPaymentInPatientHeaderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordPaymentInPatientHeaderMutation(baseOptions?: Apollo.MutationHookOptions<RecordPaymentInPatientHeaderMutation, RecordPaymentInPatientHeaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordPaymentInPatientHeaderMutation, RecordPaymentInPatientHeaderMutationVariables>(RecordPaymentInPatientHeaderDocument, options);
      }
export type RecordPaymentInPatientHeaderMutationHookResult = ReturnType<typeof useRecordPaymentInPatientHeaderMutation>;
export type RecordPaymentInPatientHeaderMutationResult = Apollo.MutationResult<RecordPaymentInPatientHeaderMutation>;
export type RecordPaymentInPatientHeaderMutationOptions = Apollo.BaseMutationOptions<RecordPaymentInPatientHeaderMutation, RecordPaymentInPatientHeaderMutationVariables>;